import { render } from "./AccountGroup.vue?vue&type=template&id=d9af2d4e"
import script from "./AccountGroup.vue?vue&type=script&lang=js"
export * from "./AccountGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__